
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue/[...venue]",
      function () {
        return require("private-next-pages/venue/[...venue].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue/[...venue]"])
      });
    }
  